const WINDOW_ENV = (window as any).env;

// eslint-disable-next-line import/prefer-default-export
export const cameraScriptControlsEnabled = WINDOW_ENV?.CAMERA_SCRIPT_CONTROLS_ENABLED === 'true' || false;
